module.exports = __webpack_public_path__ + "img/section3_1.c57f4f47.png";